export const ChevronLeft = ({ color = 'black' }) => (
  <svg xmlns='http://www.w3.org/2000/svg' width='9' height='12' viewBox='0 0 9 12' fill='none'>
    <path d='M7.9436 1L2 5.97635L8 11' stroke={color} strokeWidth='2' strokeLinecap='round' />
  </svg>
)
